import { useState, useCallback } from 'react';
import CustomSIPHeaderEdit from './CustomSIPHeaderEdit.jsx';
import CustomSIPHeadersTable from './CustomSIPHeadersTable.jsx';
import useGetAllCustomSIPHeaders from './queries/useGetAllCustomSIPHeaders.jsx';
import { CUSTOM_SIP_HEADER_MODES } from './constants.js';

const CustomSIPHeadersIndex = () => {
    const [mode, setMode] = useState(CUSTOM_SIP_HEADER_MODES.MAIN_TABLE);
    const [selectedHeaderId, setSelectedHeaderId] = useState(null);

    const [tableData, setTableData] = useState({
        columns: [],
        data: [],
    });

    const { isLoading, isRefetching, isFetching, refetch } =
        useGetAllCustomSIPHeaders(setTableData);

    const switchMode = useCallback((newMode, headerId = null) => {
        setMode(newMode);
        if (headerId !== null) {
            setSelectedHeaderId(headerId);
        }
    }, []);

    const resetToMainTable = useCallback(() => {
        setMode(CUSTOM_SIP_HEADER_MODES.MAIN_TABLE);
        setSelectedHeaderId(null);
        refetch();
    }, [refetch]);

    const handleAdd = useCallback(() => {
        switchMode(CUSTOM_SIP_HEADER_MODES.ADD);
    }, [switchMode]);

    const handleEdit = useCallback(
        (params) => {
            setSelectedHeaderId(params.data.id);
            switchMode(CUSTOM_SIP_HEADER_MODES.EDIT);
        },
        [switchMode],
    );

    const modalContent = () => {
        switch (mode) {
            case CUSTOM_SIP_HEADER_MODES.ADD:
                return (
                    <CustomSIPHeaderEdit
                        mode="Add"
                        resetToMainTable={resetToMainTable}
                    />
                );
            case CUSTOM_SIP_HEADER_MODES.EDIT:
                return (
                    <CustomSIPHeaderEdit
                        mode="Edit"
                        selectedHeaderID={selectedHeaderId}
                        resetToMainTable={resetToMainTable}
                    />
                );
            case CUSTOM_SIP_HEADER_MODES.MAIN_TABLE:
            default:
                return (
                    <CustomSIPHeadersTable
                        tableData={tableData}
                        isLoading={isLoading}
                        isRefetching={isRefetching}
                        isFetching={isFetching}
                        refetch={refetch}
                        handleAdd={handleAdd}
                        handleEdit={handleEdit}
                    />
                );
        }
    };

    return <>{modalContent()}</>;
};

export default CustomSIPHeadersIndex;
